import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Button, Fade, Menu } from "@mui/material";
import React from "react";

import variables from "../../../assets/styles/_variables.module.scss";
type TProps = {
    disabled?: boolean;
    anchorEls: { [index: number]: HTMLElement | null };
    setAnchorEls: React.Dispatch<React.SetStateAction<{ [index: number]: HTMLElement | null }>>;
    handleClose: (id: number) => void;
    children: React.ReactNode;
    id: number;
};
const StockControls = ({ disabled, anchorEls, setAnchorEls, handleClose, children, id }: TProps) => {
    const open = Boolean(anchorEls[id]);
    const handleClick = (event: React.MouseEvent<HTMLElement>, id: number) => {
        setAnchorEls((prev) => ({
            ...prev,
            [id]: event.currentTarget,
        }));
    };
    return (
        <>
            <Button
                disabled={disabled}
                sx={{
                    color: variables["secondary-purple"],
                    minWidth: "unset",
                    "&:hover": {
                        backgroundColor: variables["purple-20-op"],
                    },
                    padding: "2px",
                }}
                style={{ background: `${open ? variables["purple-20-op"] : ""} ` }}
                onClick={(e) => {
                    handleClick(e, id);
                }}
                id={`general-table-row-${id}-details-btn`}
            >
                <MoreHorizIcon sx={{ cursor: "pointer", fill: disabled ? "grey" : "black" }} />
            </Button>
            <Menu
                anchorEl={anchorEls[id]}
                open={open}
                onClose={() => handleClose(id)}
                TransitionComponent={Fade}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                sx={{
                    ".MuiPaper-root": {
                        marginTop: "2px",
                        boxShadow: "none",
                        border: `1px solid ${variables["border-grey"]}`,
                        ".MuiList-root": {
                            padding: "0px",
                            "& > .MuiMenuItem-root": {
                                gap: "8px",
                                padding: "8px 16px",
                                fontSize: "0.8rem",
                                maxWidth: "300px",
                                "&:not(:last-child)": {
                                    borderBottom: `1px solid ${variables["border-grey"]}`,
                                },
                            },
                        },
                    },
                }}
            >
                {children}
            </Menu>
        </>
    );
};
export default StockControls;
